const $ = jQuery.noConflict();
import aos from './aos';

'use strict';
/**
 * @description In order to create link that scrolls to certain section, simply place '#scroll-section-example' to a desired tag and id with same value to the section page should scroll to.
 * @description Alternately, you can enable any URL with# to autoscroll on page load. For example: some - website.com / #scroll - section - example
 * @example tag: <a class="btn" href="#scroll-section-example"> will scroll to: <div class="some-section" id="scroll-section-example">
 */
const ScrollTo = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domScrollLink: $('a[href*=\\#]:not([href=\\#])'),

	/** @description Initialize */
	init: function() {
		this.bindEvents();
		this.hashScroll();
	},

	bindEvents: function() {
		const _this = this;
		let timeout = 300;
		const languageElements = $('.gt_options [data-gt-lang]');
		const allowedLanguages = languageElements.map(function() {
			return $(this).data('gt-lang').toLowerCase();
		}).get();
		const regex = new RegExp(`^/(${allowedLanguages.join('|')})/`, 'i');
		const cleanUrl = location.origin + location.pathname.replace(regex, '/');

		if (aos.isCookieSet('googtrans')) {
			timeout = 1500;
		}

		// $('.menu-item.js-allow-click a').addClass('js-allow-click');
		$('.sub-menu a[href*="?tab"]').each(function() {
			const linkHref = $(this).attr('href');
			const linkUrl = new URL(linkHref, location.origin);
			const linkPathOnly = linkUrl.origin + linkUrl.pathname;

			if (linkPathOnly !== cleanUrl) {
				$(this).addClass('js-allow-click');
			}
		});

		window.scrollTo(0, 0);

		_this.$domScrollLink.on('click', function(e) {
			const url = new URL(e.currentTarget.href);
			const cleanLink = url.origin + url.pathname;

			if (!e.currentTarget.classList.contains('js-allow-click')) {
				e.preventDefault();
			}

			const target = $(e.currentTarget.hash);

			console.log(cleanUrl);
			console.log(cleanLink);

			if (cleanUrl === cleanLink) {
				_this.scrollToTarget(target);
			}
			// else {
			// 	setTimeout(() => {
			// 		_this.scrollToTarget(target);
			// 	}, timeout);
			// }
		});
	},

	hashScroll: function() {
		const hash = window.location.hash;
		let timeout = 500;

		if (aos.isCookieSet('googtrans')) {
			timeout = 1500;
		}

		if (hash) {
			const target = $(hash);
			const cleanUrl = location.protocol + '//' + location.host + location.pathname;

			setTimeout(() => {
				window.history.pushState('', '', cleanUrl);
				this.scrollToTarget(target, 50, 500);
			}, timeout);
		}
	},

	scrollToTarget: function(target, offset = 100, scrollSpeed = 1200) {
		if (target.length) {
			$('html,body').animate({
				scrollTop: target.offset().top - offset
			}, scrollSpeed);
		}
	}
};

export default ScrollTo;
